<template lang="html">
  <div>

    <AlertList
      v-if="errors && errors.length"
      :alerts="errors"
      type="error"
      verbose
      pop-up
    />

    <v-alert v-else-if="noResults" text type="info">
      {{ $t('general.phrases.no_results') }}
    </v-alert>

    <div v-else-if="isComplete" class="text--disabled text-center text-caption">
      <span class="end-of-results">
        {{ $t('general.phrases.end_of_results') }}
      </span>
    </div>

    <div
      v-else
      v-intersect="{
        handler: moreResults,
        options: {
          threshold: [0.3],
          rootMargin: '0px 0px 400px 0px', // pushes intersection checker up with margin bottom
        },
      }"
    />
  </div>
</template>

<script>
import { clone } from 'lodash';
import { Intersect } from 'vuetify/lib/directives';
import AlertList from '@/components/AlertList.vue';

export default {
  name: 'IndexInfiniteScroller',
  components: {
    AlertList,
  },
  directives: {
    Intersect,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    recordCount: {
      type: [String, Number],
      validator(v) {
        return Number.isFinite(v);
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isComplete() {
      return this.page.offset >= this.recordCount;
    },
    _recordCount() {
      return Number.parseInt(this.recordCount) || 0;
    },
    noResults() {
      return this._recordCount === 0;
    },
  },
  methods: {
    incrementOffset() {
      if (this.isComplete) return;
      const page = clone(this.page);
      page.offset += page.limit;
      this.$emit('update:page', page);
    },
    moreResults(entries) {
      if (this.disabled) return;
      // entries is part of IntersectionObserver API
      if (entries[0].isIntersecting) {
        this.incrementOffset();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bar-distance: calc(100% + 24px);

.end-of-results {
  position: relative;

  &:before,
  &:after {
    content: '';
    width: 64px;
    height: 2px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: currentColor;
    opacity: 0.37;
  }

  &:before {
    left: $bar-distance;
  }

  &:after {
    right: $bar-distance;
  }
}
</style>
